import { DefaultFormFieldLayout } from '@bambi/component-library/src/components/forms/DefaultFormFieldLayout/DefaultFormFieldLayout';
import { PhoneInput } from '@bambi/component-library/src/components/inputs/PhoneInput';

import { FormFieldController } from 'src/common/FormField/FormFieldController';

export function PhoneNumberField({ disabled }: { disabled?: boolean }) {
  return (
    <FormFieldController
      name="phone_number"
      rules={{ required: 'Phone is required' }}
    >
      {({ field, fieldState }) => {
        return (
          <DefaultFormFieldLayout
            label="Phone Number *"
            error={fieldState.error?.message?.toString()}
            inputId="phone"
          >
            <PhoneInput {...field} dataTestId="phone" disabled={disabled} />
          </DefaultFormFieldLayout>
        );
      }}
    </FormFieldController>
  );
}
